/********************************************************************************
 * Copyright (c) 2020 Contributors to the Eclipse Foundation
 *
 * See the NOTICE file(s) distributed with this work for additional
 * information regarding copyright ownership.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 ********************************************************************************/
import { createAction, props } from '@ngrx/store';

export interface ILogoutSuccess {
  payload: string;
}

export interface ILogoutFail {
  payload: string;
}
export const logout = createAction('[Logout] Logout');
export const logoutSuccess = createAction('[Logout] Logout Success', props<ILogoutSuccess>());
export const logoutFail = createAction('[Logout] Logout Fail', props<ILogoutFail>());
